<script lang="ts">
  import Label from '$provider/constants/Label';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import AlertText from './AlertText.svelte';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';

  interface Props {
    alert: DataListAlert;
  }

  let { alert }: Props = $props();
</script>

<div class="change-new-sec-alert">
  <AlertView
    type={ListAlertType.ChangeNewSection}
    key={Label.ChangeTo}
    icon="icon-corner-down-right"
  >
    <div class="value">
      <AlertText {alert} />
    </div>
  </AlertView>
</div>

<style>
  .change-new-sec-alert {
    width: 100%;
  }
  :global(.change-new-sec-alert .list-alert) {
    display: block !important;
    padding-bottom: 20px;
  }
  .value {
    background-color: #fafbfd;
    margin: 0px 16px;
    padding: 12px;
  }
</style>
